import { useApiClient } from '@/composables/useApiClient'

export const state = () => ({
  products: [],
})

export const getters = {
  products: state => state.products?.filter(p => p.onboard) || [],
}

export const actions = {
  getFunBookHeadcount({ commit }, { bid, pid, skipResource }) {
    return new Promise((resolve, reject) => {
      const apiPath = `/branch/${bid}/headcount`
      useApiClient()
        .$get(apiPath, { params: { pid: pid, skip_resource: skipResource }, platform: 'FunBook' })
        .then(res => {
          if (res.code === 0) {
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getArrivalTimes({ commit }, { bid, pid, headcount }) {
    return new Promise((resolve, reject) => {
      const apiPath = `/branch/${bid}/arrivaltimes?pid=${pid}&count=${headcount}`
      useApiClient()
        .$get(apiPath, { platform: 'FunBook' })
        .then(res => {
          if (res.code === 0) {
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  async getBranchProducts({ commit }, { bid }) {
    const apiPath = `/branch/${bid}/products`
    const res = await useApiClient().$get(apiPath, { platform: 'FunBook' })
    if (res.code === 0) {
      commit('SET_PRODUCTS', res.data.products)
    }
  },
}

export const mutations = {
  SET_PRODUCTS(state, payload) {
    state.products = payload
  },
}
